import { render, staticRenderFns } from "./AnnualIncomeStatementTable.vue?vue&type=template&id=5548aaef&"
import script from "./AnnualIncomeStatementTable.vue?vue&type=script&lang=js&"
export * from "./AnnualIncomeStatementTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports